/**
 * La marca en movimiento, para las esperas.
 *
 * Copia del loader de la web. Las dos apps se compilan por separado y no
 * comparten componentes de React --@timecap/core es TypeScript sin
 * framework a propósito, para que valga igual en el navegador y en la
 * tablet--, así que este archivo es un duplicado consciente de 40 líneas
 * en vez de un paquete de UI compartido para un solo componente.
 */
export function Loader({ label = 'Cargando…', size = 72 }: { label?: string; size?: number }) {
  return (
    <div className="loader" role="status" aria-live="polite">
      <svg width={size} height={size} viewBox="0 0 128 128" aria-hidden="true">
        <rect x="14" y="27" width="58" height="17" rx="8.5" fill="#D2FF3A" opacity="0.72">
          <animate
            attributeName="width"
            values="17;58;17"
            dur="2.4s"
            begin="0s"
            repeatCount="indefinite"
            keyTimes="0;0.6;1"
            calcMode="spline"
            keySplines="0.4 0 0.2 1;0.4 0 0.2 1"
          />
        </rect>
        <rect x="14" y="55.5" width="85" height="17" rx="8.5" fill="#D2FF3A">
          <animate
            attributeName="width"
            values="17;85;17"
            dur="2.4s"
            begin="0.15s"
            repeatCount="indefinite"
            keyTimes="0;0.6;1"
            calcMode="spline"
            keySplines="0.4 0 0.2 1;0.4 0 0.2 1"
          />
        </rect>
        <rect x="14" y="84" width="44" height="17" rx="8.5" fill="#D2FF3A" opacity="0.46">
          <animate
            attributeName="width"
            values="17;44;17"
            dur="2.4s"
            begin="0.3s"
            repeatCount="indefinite"
            keyTimes="0;0.6;1"
            calcMode="spline"
            keySplines="0.4 0 0.2 1;0.4 0 0.2 1"
          />
        </rect>
        {/* El muro no se mueve: pulsa. Es el límite, no un competidor. */}
        <rect x="99" y="12" width="17" height="104" rx="8.5" fill="#FF3B30">
          <animate attributeName="opacity" values="1;0.45;1" dur="2.4s" repeatCount="indefinite" />
        </rect>
      </svg>
      <span className="muted">{label}</span>
    </div>
  );
}
